import { filterOnlyHavingParameterSet } from '../filters/byParameterName.js';
import buildFiltersForPitchingChart from '../filters/pitchingChartFilters.js';
import PitchData from '../enums/PitchData.js';
import ResultData from '../enums/ResultData.js';
import UniqueResultParametersProvider from './UniqueResultParametersProvider.js';
import { ChartSeries, Series, BaseballResultsProcessor } from '../entities/index.js';

const buildFiltersArray = function({
    // tagging context
    pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
    // scoring context 
    outs, balls, strikes, runnersOn,
}) {
    let pitchingChartFilters = buildFiltersForPitchingChart({
        pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn
    });

    return pitchingChartFilters.concat(
        filterOnlyHavingParameterSet(ResultData.getDataPath(PitchData.BreakH.key)),
        filterOnlyHavingParameterSet(ResultData.getDataPath(PitchData.BreakVInd.key))
    );
};

const getSeriesForMovementChart = function(
    results, customResultsProcessor, {
        // tagging context
        pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
        // scoring context 
        outs, balls, strikes, runnersOn,
    } = {}
) {
    let movementChartSeries = [];
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let movementChartFilters = buildFiltersArray({
        pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn
    });

    let pitchesWithMovementOnly =  resultsProcessor.filterData(results, movementChartFilters);
    let resultsPerPitchType = resultsProcessor.groupData(pitchesWithMovementOnly, [ResultData.getDataPath(PitchData.Classification.key)]);

    for (let pitchType in resultsPerPitchType) {
        const dataForPitchType = new Series(pitchType, 2);

        let resultsMapped = resultsProcessor.mapCollectionProperties(resultsPerPitchType[pitchType], [
            [ResultData.Id.key],
            ResultData.getDataPath(PitchData.BreakH.key),
            ResultData.getDataPath(PitchData.BreakVInd.key),
        ]);

        for (let i = 0; i < resultsMapped.length; i++) {
            let mappedResult = resultsMapped[i];
            dataForPitchType.add(
                resultsMapped[i][ResultData.Id.key],
                mappedResult[PitchData.BreakH.key],
                mappedResult[PitchData.BreakVInd.key]
            );
        }

        movementChartSeries.push(dataForPitchType);
    }

    return new ChartSeries(movementChartSeries, Object.keys(resultsPerPitchType));
};

const listUniqueParametersForMovementChart = function(
    results, customResultsProcessor,
    {
        // tagging context
        pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
        // scoring context 
        outs, balls, strikes, runnersOn,
    } = {},
    parameters,
    combinedPitchResult
) {
    parameters = parameters || [
        // tagging context
        [ResultData.BatterTagId.key],
        [ResultData.TagId.key],
        ResultData.getDataPath(PitchData.Result.key),
        ResultData.getDataPath(PitchData.Classification.key),
        ResultData.getDataPath(PitchData.Mechanics.key),
        ResultData.getDataPath(PitchData.SwingHandedness.key),
        // scoring context
        ResultData.getDataPath(PitchData.BeforePlayOuts.key),
        ResultData.getDataPath(PitchData.BeforePlayBalls.key),
        ResultData.getDataPath(PitchData.BeforePlayStrikes.key),
        ResultData.getDataPath(PitchData.BeforePlayRunnersOn.key),
    ];

    const resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let movementChartFilters = buildFiltersArray({
        pitcherId, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn
    });

    let pitchesWithMovementOnly =  resultsProcessor.filterData(results, movementChartFilters);
    
    return UniqueResultParametersProvider(pitchesWithMovementOnly, parameters, resultsProcessor, combinedPitchResult);
};

export default getSeriesForMovementChart;

export {
    getSeriesForMovementChart, listUniqueParametersForMovementChart
};